import { Card, Col, Container, Row, ListGroup } from 'react-bootstrap';
import { Box, Edit, GitHub, Gitlab, Instagram, Send } from 'react-feather';
import { Link } from 'react-router-dom';

export default function User() {
    return (
        <>
            <Container fluid>
                <Col>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>پروفایل کاربر</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/user'>کاربر</Link>
                            </li>

                            <li className='breadcrumb-item'>
                                <Link to='/user'>پروفایل کاربر</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </Col>

                <div className='space-20' />

                <Row>
                    <Col xs={12} md={6} lg={4} className='mb-4'>
                        <Card>
                            <Card.Img
                                variant='top'
                                src='https://res.cloudinary.com/amirreza/image/upload/v1639472415/shopinx%20dashboard/auth/squares_iwbyyr.png'
                                className='user-background'
                                alt='amirreza kadkhodazadeh'
                            />

                            <Link to='/setting' className='user-edit'>
                                <Edit size={20} />
                            </Link>

                            <Card.Body>
                                <div className='d-flex justify-content-center'>
                                    <Card.Img
                                        src='https://res.cloudinary.com/amirreza/image/upload/v1628080202/me_uzqd9m.jpg'
                                        variant='bottom'
                                        className='user-img'
                                        alt='amirreza kadkhodazadeh'
                                    />
                                </div>

                                <Card.Title className='ml-3'>
                                    اطلاعات کاربر
                                </Card.Title>

                                <Card.Text className='ml-3'>
                                    عشق مردم را درمان می کند، هم کسانی که آن را
                                    می دهند و هم کسانی که آن را دریافت می کنند.
                                </Card.Text>

                                <ul
                                    className='list-group'
                                    style={{
                                        paddingLeft: '0',
                                    }}
                                >
                                    <li className='list-group-item border-0'>
                                        <strong>نام کامل : </strong>
                                        امیررضا کدخدازاده
                                    </li>

                                    <li className='list-group-item border-0'>
                                        <strong>شغل : </strong>
                                        توسعه دهنده فرانت اند
                                    </li>

                                    <li className='list-group-item border-0'>
                                        <strong>آدرس ایمیل : </strong>
                                        amirreza.dev@protonmail.com
                                    </li>

                                    <li className='list-group-item border-0'>
                                        <strong>تلفن همراه : </strong>
                                        4567 123 0912
                                    </li>

                                    <li className='list-group-item border-0'>
                                        <strong>محل زندگی : </strong>
                                        کرج، مهرشهر
                                    </li>

                                    <li className='list-group-item border-0'>
                                        <strong>شبکه اجتماعی : </strong>

                                        <a href='/'>
                                            <Instagram size={17} />
                                        </a>

                                        <a href='/' className='ml-3'>
                                            <GitHub size={17} />
                                        </a>

                                        <a href='/' className='ml-3'>
                                            <Gitlab size={17} />
                                        </a>

                                        <a href='/' className='ml-3'>
                                            <Send size={17} />
                                        </a>
                                    </li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xs={12} md={6} lg={4} className='mb-4'>
                        <Card>
                            <Card.Header className='bg-transparent border-bottom-0 p-3'>
                                گفتگو ها
                            </Card.Header>

                            <Card.Body>
                                <ListGroup
                                    as='ul'
                                    style={{
                                        paddingLeft: '0',
                                    }}
                                >
                                    <ListGroup.Item
                                        as='li'
                                        className='d-flex justify-content-between align-items-start border-0 mb-2'
                                    >
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1640970983/shopinx%20dashboard/users/PinClipart.com_prediction-clipart_3553881_z7zoqb.png'
                                            alt='کاربر'
                                            width='50'
                                            height='50'
                                            className='rounded'
                                        />

                                        <div className='me-2 ms-auto mt-2'>
                                            <div className='fw-bold'>علی</div>
                                            <small>
                                                آقا برنامه برای آخر هفته چی شد ؟
                                            </small>
                                        </div>

                                        <Link to='/chat' className='mt-2'>
                                            پاسخ
                                        </Link>
                                    </ListGroup.Item>

                                    <ListGroup.Item
                                        as='li'
                                        className='d-flex justify-content-between align-items-start border-0 mb-2'
                                    >
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1640970741/shopinx%20dashboard/users/3_orvzfa.jpg'
                                            alt='کاربر'
                                            width='50'
                                            height='50'
                                            className='rounded'
                                        />

                                        <div className='me-2 ms-auto mt-2'>
                                            <div className='fw-bold'>میلاد</div>
                                            <small>حتما باهام تماس بگیر</small>
                                        </div>

                                        <Link to='/chat' className='mt-2'>
                                            پاسخ
                                        </Link>
                                    </ListGroup.Item>

                                    <ListGroup.Item
                                        as='li'
                                        className='d-flex justify-content-between align-items-start border-0 mb-2'
                                    >
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1640970740/shopinx%20dashboard/users/6_ew5mm6.jpg'
                                            alt='کاربر'
                                            width='50'
                                            height='50'
                                            className='rounded'
                                        />

                                        <div className='me-2 ms-auto mt-2'>
                                            <div className='fw-bold'>محمد</div>
                                            <small>سلام چه خبر ؟</small>
                                        </div>

                                        <Link to='/chat' className='mt-2'>
                                            پاسخ
                                        </Link>
                                    </ListGroup.Item>

                                    <ListGroup.Item
                                        as='li'
                                        className='d-flex justify-content-between align-items-start border-0 mb-2'
                                    >
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1640970740/shopinx%20dashboard/users/4_rrondn.jpg'
                                            alt='کاربر'
                                            width='50'
                                            height='50'
                                            className='rounded'
                                        />

                                        <div className='me-2 ms-auto mt-2'>
                                            <div className='fw-bold'>سجاد</div>
                                            <small>
                                                محصول جدید هم دارین که برای...
                                            </small>
                                        </div>

                                        <Link to='/chat' className='mt-2'>
                                            پاسخ
                                        </Link>
                                    </ListGroup.Item>

                                    <ListGroup.Item
                                        as='li'
                                        className='d-flex justify-content-between align-items-start border-0 mb-2'
                                    >
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1640970740/shopinx%20dashboard/users/2_ycyrgw.jpg'
                                            alt='کاربر'
                                            width='50'
                                            height='50'
                                            className='rounded'
                                        />

                                        <div className='me-2 ms-auto mt-2'>
                                            <div className='fw-bold'>رضا</div>
                                            <small>سلام</small>
                                        </div>

                                        <Link to='/chat' className='mt-2'>
                                            پاسخ
                                        </Link>
                                    </ListGroup.Item>

                                    <ListGroup.Item
                                        as='li'
                                        className='d-flex justify-content-between align-items-start border-0 mb-2'
                                    >
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1640970740/shopinx%20dashboard/users/5_wlgnn3.jpg'
                                            alt='کاربر'
                                            width='50'
                                            height='50'
                                            className='rounded'
                                        />

                                        <div className='me-2 ms-auto mt-2'>
                                            <div className='fw-bold'>
                                                مهرداد
                                            </div>
                                            <small>
                                                پس شما با من تماس بگیر که...
                                            </small>
                                        </div>

                                        <Link to='/chat' className='mt-2'>
                                            پاسخ
                                        </Link>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xs={12} md={6} lg={4} className='mb-4'>
                        <Col xs={12}>
                            <div className='credit-card mb-4'>
                                <div className='flip'>
                                    <div className='front blue-card'>
                                        <Box className='logo' size={40} />

                                        <div className='investor'>
                                            کارت بانک شماره یک
                                        </div>

                                        <div className='chip'>
                                            <div className='chip-line' />
                                            <div className='chip-line' />
                                            <div className='chip-line' />
                                            <div className='chip-line' />
                                            <div className='chip-main' />
                                        </div>

                                        <div className='space-40' />

                                        <div className='card-number'>
                                            <div>5022</div>

                                            <div>2910</div>

                                            <div>1234</div>

                                            <div>1234</div>
                                        </div>

                                        <div className='exp'>
                                            <span className='exp-text'>
                                                تاریخ انقضا :
                                            </span>

                                            <span className='exp-date'>
                                                {' '}
                                                11/99
                                            </span>
                                        </div>

                                        <div className='card-holder'>
                                            امیررضا کدخدازاده
                                        </div>
                                    </div>

                                    <div className='back'>
                                        <div className='strip-black' />

                                        <div className='ccv'>
                                            <label>ccv</label>
                                            <div>123</div>
                                        </div>

                                        <div className='terms'>
                                            <p>
                                                خواهشمند است از افشای رمز کارت و
                                                انتخاب رمز های قابل حدس برای
                                                کارت خودداری فرمایید.
                                            </p>
                                            <p>
                                                از یابنده کارت تقاضا می شود آنرا
                                                به یکی از شعبه های بانک ملت
                                                تحویل دهد.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={12}>
                            <div className='credit-card'>
                                <div className='flip'>
                                    <div className='front red-card'>
                                        <Box className='logo' size={40} />

                                        <div className='investor'>
                                            کارت بانک شماره دو
                                        </div>

                                        <div className='chip'>
                                            <div className='chip-line' />
                                            <div className='chip-line' />
                                            <div className='chip-line' />
                                            <div className='chip-line' />
                                            <div className='chip-main' />
                                        </div>

                                        <div className='space-40' />

                                        <div className='card-number'>
                                            <div>5022</div>

                                            <div>2910</div>

                                            <div>5678</div>

                                            <div>5678</div>
                                        </div>

                                        <div className='exp'>
                                            <span className='exp-text'>
                                                تاریخ انقضا :
                                            </span>

                                            <span className='exp-date'>
                                                {' '}
                                                07/99
                                            </span>
                                        </div>

                                        <div className='card-holder'>
                                            امیررضا کدخدازاده
                                        </div>
                                    </div>

                                    <div className='back'>
                                        <div className='strip-black' />

                                        <div className='ccv'>
                                            <label>ccv</label>
                                            <div>123</div>
                                        </div>

                                        <div className='terms'>
                                            <p>
                                                خواهشمند است از افشای رمز کارت و
                                                انتخاب رمز های قابل حدس برای
                                                کارت خودداری فرمایید.
                                            </p>
                                            <p>
                                                از یابنده کارت تقاضا می شود آنرا
                                                به یکی از شعبه های بانک ملت
                                                تحویل دهد.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Col>
                </Row>

                <div className='space-20' />

                <Row>
                    <Col xs={12} md={6}>
                        <Card>
                            <Card.Header className='bg-transparent p-3 border-0'>
                                <span>گالری</span>

                                <Link to='/' className='float-start'>
                                    <small>مشاهده همه</small>
                                </Link>
                            </Card.Header>

                            <Card.Body>
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1628063185/samples/food/dessert.jpg'
                                            alt=''
                                            className='user-gallery mb-3 rounded'
                                        />
                                    </Col>

                                    <Col xs={12} lg={6}>
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1634744564/shopinx/search/img-search-3_si3tnj.jpg'
                                            alt=''
                                            className='user-gallery mb-3 rounded'
                                        />
                                    </Col>

                                    <div className='space-10' />

                                    <Col xs={12} lg={6}>
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1634744564/shopinx/search/img-search-4_aockkv.jpg'
                                            alt=''
                                            className='user-gallery mb-3 rounded'
                                        />
                                    </Col>

                                    <Col xs={12} lg={6}>
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1634744565/shopinx/search/img-search-1_arlpfo.jpg'
                                            alt=''
                                            className='user-gallery mb-3 rounded'
                                        />
                                    </Col>

                                    <div className='space-10' />

                                    <Col xs={12} lg={6}>
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1634744565/shopinx/search/img-search-2_tqf2l5.jpg'
                                            alt=''
                                            className='user-gallery mb-3 rounded'
                                        />
                                    </Col>

                                    <Col xs={12} lg={6}>
                                        <img
                                            src='https://res.cloudinary.com/amirreza/image/upload/v1628063186/samples/food/pot-mussels.jpg'
                                            alt=''
                                            className='user-gallery mb-3 rounded'
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xs={12} md={6}>
                        <Card>
                            <Card.Header className='bg-transparent p-3 border-0'>
                                <span>گالری</span>

                                <Link to='/' className='float-start'>
                                    <small>مشاهده همه</small>
                                </Link>
                            </Card.Header>

                            <Card.Body>
                                <h1>hello world</h1>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
